import { Component, inject, Input } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialog } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DialogWarnComponent } from '@components/dialogs/dialog-warn/dialog-warn.component'
import { URL_LEGEND } from '@core/constants/constant.data'
import { LayerUploaded } from '@core/models/layers.model'
import { UploadedLayersService } from '@core/services/layers-uploaded.service'

@Component({
  selector: 'app-card-layer-shared',
  templateUrl: './card-layer-shared.component.html',
  imports: [
    // Material
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatButtonModule,
    MatIcon,
  ],
})
export class LayerSharedCardComponent {
  @Input({ required: true }) layer!: LayerUploaded

  uploadedLayersService = inject(UploadedLayersService)
  private readonly _dialog = inject(MatDialog)
  imageUrl = URL_LEGEND

  deleteLayerWithConfirm(uploadedFile: LayerUploaded): void {
    let title = 'Remove shared layer'

    const question = `Are you sure you want to remove this layer "${uploadedFile.name}" that has been shared to you ? `

    const data = {
      title: title,
      message: question,
    }
    const dialogRef = this._dialog.open(DialogWarnComponent, {
      data: data,
    })

    dialogRef.afterClosed().subscribe((deletionConfirm) => {
      if (deletionConfirm) {
        this._deleteSharedLayer(uploadedFile)
      }
    })
  }

  private async _deleteSharedLayer(layer: LayerUploaded) {
    let response = await this.uploadedLayersService.deleteSharedLayer(layer.id)

    if (!response) return
    this.uploadedLayersService.removeUploadedLayerFromMap(layer)
  }
}
